import {useMemo} from 'react'
import * as React from 'react'

import useEventIdCallback from '../../../../../hooks/useEventIdCallback'
import IconButton from '../../../../common/IconButton/IconButton'
import {BuildIdContext} from '../../FullBuildLog/FullBuildLog.context'
import LogMessageMenu from '../LogMessageMenu/LogMessageMenu'

import styles from './LogMessageActions.css'

type Props = {
  id: number
  text: string
  expanded: boolean
  expandable: boolean
  onClick: (event: React.MouseEvent, id: number) => unknown
  timestamp: string
  serverTimestamp?: string
  toggleMessageSubtree: (index: number, expand: boolean) => unknown
}

function LogMessageActions({
  onClick,
  timestamp,
  serverTimestamp,
  id,
  text,
  expanded,
  expandable,
  toggleMessageSubtree,
}: Props) {
  const buildId = React.useContext(BuildIdContext)
  const handleClick = useEventIdCallback<React.MouseEvent, number>(onClick, id)

  const anchor = useMemo(
    () => <IconButton className={styles.button} title={'Actions'} icon={'more-options'} />,
    [],
  )

  if (buildId == null) {
    return null
  }

  return (
    <div role="presentation" onClick={handleClick}>
      <LogMessageMenu
        id={id}
        expanded={expanded}
        expandable={expandable}
        toggleMessageSubtree={toggleMessageSubtree}
        text={text}
        timestamp={timestamp}
        serverTimestamp={serverTimestamp}
        anchor={anchor}
      />
    </div>
  )
}

export default React.memo(LogMessageActions)
